import React from 'react'
import Navbar from '../Navbar';
import Footer from '../Footer';
import investerBanner from '../../assests/investor relationship/handshake.webp';
import '../../hamcss/investor.css';
import { useState } from 'react'
import { FaRegFilePdf } from "react-icons/fa";
import { Link } from 'react-router-dom';

import moongipa from '../../assests/sgPdf/employee-benefit/Employee Benefit Scheme.pdf';
import esop from '../../assests/sgPdf/employee-benefit/ESOP 2026.pdf';



const EmployeeBenefitScheme = () => {

    const [selectedOption, setSelectedOption] = useState("option"); // State to track selected option

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value); // Update selected option when changed
    };


    return (
        <>

            <Navbar />
            <section>
                <div className="BreadArea" style={{
                    //  for /beta server 
                    backgroundImage: `url(${investerBanner})`,
                    // backgroundImage: "url('images/Bread.png')",
                }}>
                    <div className="container">
                        <h2>Annual Return_Section 92 of Companies Act 2013</h2>
                    </div>
                </div>
            </section>


            <section className="main-an">

                <div className="main-an-box">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h2 className='h2-text'>	Employee Benefit Schemes</h2>
                        <div>
                            <select className="select-class" style={{ width: '100%' }} onChange={handleOptionChange}>
                                <option value="option">SG Finserve Limited Employee Stock Option Scheme – 2026</option>
                                <option value="option1">Moongipa Securities Limited Employees Stock Option Scheme – 2022</option>
                                

                            </select>
                        </div>
                    </div>

                    <div style={{ marginTop: '50px' }}>
                        {/* Conditionally render PDFs based on selected option */}
                        {selectedOption === "option" && (
                            <>
                                <div className="pdf-clas-2">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={esop} target='blank'>  <h6>SG Finserve Limited Employee Stock Option Scheme – 2026</h6> </a>
                                </div>
                               
                            </>
                        )}
                         {selectedOption === "option1" && (
                            <>
                                <div className="pdf-clas-2">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={moongipa} target='blank'>  <h6>Moongipa Securities Limited Employees Stock Option Scheme – 2022</h6> </a>
                                </div>
                                


                            </>
                        )}
                        




                       


                     
                    </div>
                </div>

            </section>



            <Footer />


        </>
    )
}



export default EmployeeBenefitScheme